/** UUIDv7: time-ordered, client-generated, globally unique before any row reaches the server. */
export function uuidv7(now: number = Date.now()): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  const ts = BigInt(now);
  bytes[0] = Number((ts >> 40n) & 0xffn);
  bytes[1] = Number((ts >> 32n) & 0xffn);
  bytes[2] = Number((ts >> 24n) & 0xffn);
  bytes[3] = Number((ts >> 16n) & 0xffn);
  bytes[4] = Number((ts >> 8n) & 0xffn);
  bytes[5] = Number(ts & 0xffn);
  bytes[6] = (bytes[6]! & 0x0f) | 0x70; // version 7
  bytes[8] = (bytes[8]! & 0x3f) | 0x80; // variant
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/**
 * Hybrid logical clock stamp for `updated_at`: wall-clock ms plus a counter so writes on one device
 * are strictly ordered and last-write-wins is stable across devices with skewed clocks.
 * Encoded as a sortable string: `<ms:13>-<counter:4>-<node:4>`.
 */
export function createHlc(node: string) {
  let lastMs = 0;
  let counter = 0;
  const nodeId = node.slice(-4).padStart(4, '0');
  return {
    now(wallMs: number = Date.now()): string {
      const ms = Math.max(wallMs, lastMs);
      counter = ms === lastMs ? counter + 1 : 0;
      lastMs = ms;
      return `${String(ms).padStart(13, '0')}-${counter.toString(16).padStart(4, '0')}-${nodeId}`;
    },
    /** Merge an observed remote stamp so subsequent local stamps sort after it. */
    observe(remote: string) {
      const ms = Number(remote.slice(0, 13));
      if (ms > lastMs) { lastMs = ms; counter = 0; }
    },
  };
}
export type Hlc = ReturnType<typeof createHlc>;
